import { createAction } from '@mews-framework/redux';
import { SetSentryTagsProps } from '../../../services';

export const TAGS_SET = '@@sentry/TAGS_SET';

export const setSentryTags = (tags: SetSentryTagsProps) => createAction(TAGS_SET, tags);

export type SetSentryTagsAction = ReturnType<typeof setSentryTags>;
